var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgCake = function SvgCake(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_256",
    "data-name": "Rectangle 256",
    width: 12,
    height: 14,
    transform: "translate(2)",
    fill: "#22282F"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame_3300",
    "data-name": "Frame 3300",
    transform: "translate(-2)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M8.453,3.742A1.274,1.274,0,0,0,9.32,2.7a1.2,1.2,0,0,0-.187-.808L8.28.477a.346.346,0,0,0-.58,0L6.847,1.89a1.277,1.277,0,0,0-.18.655A1.329,1.329,0,0,0,8.453,3.742Zm2.567,6.389-.667-.636-.72.681a2.444,2.444,0,0,1-3.26,0L5.66,9.495l-.727.681a2.346,2.346,0,0,1-1.627.643A2.394,2.394,0,0,1,2,10.43v2.3A1.308,1.308,0,0,0,3.333,14h9.333A1.308,1.308,0,0,0,14,12.727v-2.3a2.4,2.4,0,0,1-1.827.331A2.373,2.373,0,0,1,11.02,10.131Zm.98-4.4H8.667V5.091a.667.667,0,0,0-1.333,0v.636H4A1.954,1.954,0,0,0,2,7.636v.929A1.288,1.288,0,0,0,2.873,9.8a1.363,1.363,0,0,0,1.353-.293L5.653,8.152l1.42,1.355a1.357,1.357,0,0,0,1.847,0l1.427-1.355,1.42,1.355a1.342,1.342,0,0,0,1.1.35,1.318,1.318,0,0,0,1.127-1.311v-.9A1.945,1.945,0,0,0,12,5.727Z",
    fill: "#22282F",
    fillRule: "evenodd"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgCake);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Cake.ec3f7f141883466b0263d62983f29c0d.svg";